import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';
import {useRef} from 'react';
import {IIndicatorData} from '../utils/types';
import BarChart, {BarLabels} from './BarChart';
import ChartExportMenu, {EXPORT_IGNORE} from './ChartExportMenu';

interface IndicatorProps {
    roman: string;
    title: string;
    tooltip: string;
    data: IIndicatorData;
    isCount?: boolean;
    maxOverride?: number;
    labels?: BarLabels;
}

const Indicator = ({roman, title, tooltip, data, isCount, maxOverride, labels}: IndicatorProps) => {
    const chartRef = useRef<HTMLDivElement>(null);

    return (
        <Box ref={chartRef} sx={{mb: 2.5}}>
            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 0.75, mb: 1}}>
                <Typography
                    variant='caption'
                    sx={{
                        width: 24,
                        flexShrink: 0,
                        color: 'text.disabled',
                        fontWeight: 500,
                        pt: '2px',
                        textAlign: 'right',
                    }}
                >
                    {roman}
                </Typography>
                <Typography variant='body2' color='text.secondary' sx={{flex: 1, lineHeight: 1.45}}>
                    {title}
                </Typography>
                {tooltip && (
                    <Tooltip title={tooltip} placement='top' arrow>
                        <IconButton {...EXPORT_IGNORE} size='small' sx={{p: '2px', color: 'text.disabled', flexShrink: 0}}>
                            <InfoOutlinedIcon sx={{fontSize: 15}} />
                        </IconButton>
                    </Tooltip>
                )}
                <ChartExportMenu target={chartRef} title={title} />
            </Box>
            <Box sx={{pl: '32px'}}>
                <BarChart uoaValue={data.uoa} groupValue={data.group} averageValue={data.average} isCount={isCount} maxOverride={maxOverride} labels={labels} />
            </Box>
        </Box>
    );
};

export default Indicator;
